<template>
  <div :class="$style.container">
    <!-- TODO: @danealton переработать компонент поля ввода url -->
    <input-link
      ref="accountLink"
      v-model="accountLink"
      input-id="input-link"
      data-test="accountCreatingProjectLinkInput"
      :input-name="$t('link.to.project.or.account')"
      :input-title="$t('indicate.link.to.project.or.account')"
      :input-placeholder="$t('common.link')"
      :required="false"
      :disabled="loading"
      :max-length="500"
      capusta-info="registration"
      @focus="isFocusOnAccountLink = true"
      @blur="isFocusOnAccountLink = false"
    />

    <div :class="[$style.submit, { [$style.primary]: isShownPrimarySubmitButton }]">
      <simple-button
        v-show="isShownPrimarySubmitButton"
        variant="secondary"
        :disabled="!isValid"
        @click="handleSubmit"
      >
        {{ $t('common.proceed') }}
      </simple-button>
      <simple-button
        v-show="!isShownPrimarySubmitButton"
        variant="darken"
        size="small"
        @click="handleAlternativeSubmit"
      >
        {{ $t('registration.account.submit.alternative') }}
      </simple-button>
    </div>
  </div>
</template>

<script>
import InputLink from '@/components/inputElements/InputLink';
import SimpleButton from 'molecules/common/SimpleButton';

import { LANDING_URL } from 'root/.env';

const ALTERNATIVE_ACCOUNT_LINK = `${LANDING_URL}/my-link`;

export default {
  name: 'AccountCreatingForm',
  components: {
    InputLink,
    SimpleButton,
  },
  props: {
    loading: Boolean,
  },
  data() {
    return {
      accountLink: '',
      isFocusOnAccountLink: false,
    };
  },
  computed: {
    isValid() {
      if (this.loading) {
        return false;
      }

      const isValidAccountLink = this.$validate.isNotEmptyString(this.accountLink) && this.$refs.accountLink && !this.$refs.accountLink.$v.$error;

      return isValidAccountLink;
    },
    isShownPrimarySubmitButton() {
      if (this.isFocusOnAccountLink) {
        return true;
      }

      return this.$validate.isNotEmptyString(this.accountLink);
    },
  },
  methods: {
    handleSubmit() {
      if (!this.isValid) {
        this.$alert({
          type: 'warning',
          text: this.$t('mistakes.in.form'),
        });
        return;
      }

      this.$emit('submit', {
        link: this.accountLink,
      });
    },
    handleAlternativeSubmit() {
      this.$emit('submit', {
        link: ALTERNATIVE_ACCOUNT_LINK,
      });
    },
  },
};
</script>

<style lang="sass" module>
  .submit
    margin-top: 20px

    +respond-to('medium')
      max-width: 262px
      margin-top: 50px

  .primary
    +respond-to('medium')
      max-width: 224px
</style>
